export type EdgeApiResponse<TResult = any> = {
    err?: number
    errmsg?: string
    id: string
    method: string
    responseVer: number
    result: TResult | null
}

export const fetchStatusResolver = (response: Response) => {
    if (response.status === 200) {
        return response
    } else {
        throw new Error(`${response.status}: ${response.statusText}`)
    }
}
